/* ============================================================
   홈 뷰 — 본문 영역 (PINNED + PORTAL)
   search-bar / stats-footer는 App 공통 영역으로 격상됨 (2026-05-12)
   2026-05-13 App.tsx 분리
   ============================================================ */
import { DOMAIN_CARDS, STATUS_LABEL } from '../data'
import { ICONS } from '../icons'

export function HomeView({ openDomain }: { openDomain: (c: string) => void }) {
  return (
    <div>
      {/* PINNED */}
      <div className="pinned-section">
        <h2 className="section-title">
          자주 가는 게시판
          <span className="meta">PINNED — 핀 시스템 Phase 2 도입 예정</span>
        </h2>
        <div className="pin-grid">
          <div className="pin-card">
            <div className="pin-name">mg_system.system_rules</div>
            <div className="pin-label">운영규칙</div>
          </div>
          <div className="pin-card">
            <div className="pin-name">mg_system.mg_memory</div>
            <div className="pin-label">아처 메모리</div>
          </div>
          <div className="pin-card">
            <div className="pin-name">mg_system.v_project_resume</div>
            <div className="pin-label">프로젝트 리줌</div>
          </div>
          <div className="pin-card">
            <div className="pin-name">mg_system.project_progress</div>
            <div className="pin-label">프로젝트 프로그레스</div>
          </div>
        </div>
      </div>

      {/* PORTAL */}
      <div className="portal-section">
        <h2 className="section-title">
          프로그램 바로가기
          <span className="meta">PORTAL · 9 도메인 셸 · 분산-통합 양방향 동기화</span>
        </h2>
        <div className="portal-grid">
          {DOMAIN_CARDS.map(card => {
            const IconRender = ICONS[card.icon]
            return (
              <div
                key={card.code}
                className="portal-card"
                onClick={() => openDomain(card.code)}
              >
                <div className="top">
                  <span className="icon">{IconRender ? IconRender() : null}</span>
                  <span className="num">{card.num}</span>
                </div>
                <div>
                  <div className="label">{card.label}</div>
                  <div className="desc">{card.desc}</div>
                </div>
                <div className="meta">
                  <span>
                    <span className={`status-dot ${card.status}`}></span>
                    {STATUS_LABEL[card.status]} · {card.meta}
                  </span>
                  <span className="arrow">→</span>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
